import type { DashboardRole } from "@/pages/home/components/role-dashboard/types/dashboard-role.types";

import { ROLE_SIDEBAR_PATHS } from "../constants/sidebar-role.constants";
import type { NavItem } from "../types/nav-item.types";

export function filterNavItemsByRole(items: NavItem[], role: DashboardRole): NavItem[] {
    const allowedPaths = ROLE_SIDEBAR_PATHS[role];
    if (!allowedPaths) {
        return items;
    }

    const allowed = new Set<string>(allowedPaths);

    const filterItems = (navItems: NavItem[]): NavItem[] =>
        navItems.flatMap((item) => {
            const children = item.children ? filterItems(item.children) : [];
            const isPathAllowed = item.to !== undefined && allowed.has(item.to);

            if (isPathAllowed) {
                return [
                    {
                        ...item,
                        children: children.length > 0 ? children : undefined,
                    },
                ];
            }

            return children;
        });

    return filterItems(items);
}
